const fileLimit = 10;
const imageInputsContainer = document.getElementById('imageInputsContainer');
const addImageInputButton = document.getElementById('addImageInput');

addImageInputButton.addEventListener('click', () => {
    const currentInputs = imageInputsContainer.getElementsByTagName('input').length;
    const additionalImageInput = '<div class="form-control"><label class="hidden" for="custom-photo-' + (currentInputs + 1) + '">Photo</label><input required="false" id="custom-photo-' + (currentInputs + 1) + '" type="file" accept="image/*" name="properties[Photo ' + (currentInputs + 1) + ']"></div>';

    if (currentInputs < fileLimit) 
    {
        if (currentInputs == fileLimit - 1) 
        {
            addImageInputButton.disabled = true;
            addImageInputButton.classList.add('hidden');
        }      
      
        imageInputsContainer.insertAdjacentHTML('beforeend', additionalImageInput);
    } 
});